// require all prototypes from the prototype file
import * as prototype from "./prototypes";
import { baseURL, baseURL1 } from "./baseURL";
import axios from "axios";
import { Configuration, OpenAIApi } from 'openai';
import { v4 as uuidv4 } from "uuid";
import { useSelector } from "react-redux";
import * as translate from "./convertResume"
import { store } from "./ConfigureStore"

//login loading dispatching function
export const login_loading = () => ({
  type: prototype.LOGIN_LOADING,
});

// login failed dispatching function
export const login_failed = (response) => ({
  type: prototype.LOGIN_FAILED,
  payload: response
});

//login dispatching function
export const login_success = (response) => ({
  type: prototype.LOGIN_USER,
  payload: response
});

export const clearLogin = () => async (dispatch) => {
  dispatch(login_loading(true));
  dispatch(existing_resume_loading(true));
  dispatch(userNameInfo_loading(true));
  dispatch(getting_cv_details_loading(true));
  dispatch(getting_profile_loading(true));
  dispatch(v_mail_loading(true));
  dispatch(r_reset_loading(true));
  dispatch(ActivitiesDetails_loading(true));
  dispatch(skillsDetails_loading(true));
  dispatch(JobtitleDetails_loading(true));
  dispatch(Professional_summary_loading(true));
  dispatch(clearStoredValue());
  dispatch(cv_id_loading(true));
  dispatch(cv_loading(true));
  dispatch(resume_step_jump_function(0));
  dispatch(about_loading(true));
  dispatch(secret_loading(true));
  // dispatch(save_link_loading(true));
}

export const logOut = () => async (dispatch) => {
  fetch(baseURL + "/api/users/logout", {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    }
  })
  .then(resp => resp.json())
  .then(resp => {
    console.log(resp.message)
  })
}

// login function
// cred means the credentials for logging in (username, passowrd, acctType-> official or client)

export const signInFunction = (cred) => async (dispatch) => {
 // upon calling this fuction first dispatch a loading status into the store
 dispatch(login_loading(true));
 const mail = cred.username.trim();
 const pass = cred.password.trim();
 let obj = {
  username: mail,
  password: pass
 }
 return axios.post(baseURL + '/api/users/signin', obj, {
  headers: {
    "Content-Type": "application/json"
  }
 })
 .then(resp => {
  if (resp.data.data.success === true) {
    dispatch(login_success(resp.data.data.profile_status));
    const store_value = store.getState();
    console.log("link", store_value.userLink.message)
    console.log('log in resp', resp)

    if (store_value.userLink.message !== null) {
      localStorage.setItem('token', resp.data.data.token)
      window.location.assign(store_value.userLink.message);
    } else {
      localStorage.setItem('token', resp.data.data.token)
      if (resp.data.data.profile_status.AcctType === "Client") {
        if (resp.data.data.profile_status.profile_status === true) {
          window.location.assign(baseURL1 + `/user/dashboard?token=${resp.data.data.token}&AcctType=Client&profile_status=true`)
        } else if (resp.data.data.profile_status.profile_status === false) {
          window.location.assign(baseURL1 + `/user/dashboard1?token=${resp.data.data.token}&AcctType=Client&profile_status=false`)
        }
      } else if (resp.data.data.profile_status.AcctType === 'Official') {
        if (resp.data.data.profile_status.profile_status === true) {
          window.location.assign(baseURL1 + `/user/employer/profile?token=${resp.data.data.token}&AcctType=Official&&profile_status=true`)
        } else if (resp.data.data.profile_status.profile_status === false) {
          window.location.assign(baseURL1 + `/user/employer/form?token=${resp.data.data.token}&AcctType=Official&&profile_status=false`)
        }
      }
    }
  } else {
    dispatch(login_failed("Incorrect password or username"));
  }
 }).catch(err => {
  console.log("This error occurred while logging in", err);
  dispatch(login_failed(err.response.data.data.status));
 })
}

// logout loading dispatch fucntion

export const logout_loading = () => ({
  type: prototype.LOGOUT_LOADING,
});

export const logout_success = (response) => ({
  type: prototype.LOG_OUT,
  payload: response
});

export const logout = () => async (dispatch) => {
  dispatch(logout_loading(true));

  return axios.post(baseURL + "/api/users/logout")
  .then(resp => {
    if (resp.success === true) {
      localStorage.clear();
      dispatch(logout_success(resp.message));
      dispatch(cv_loading(true));
      window.location.assign(resp.status);
    }
  }).catch(err => {
    console.log("An error occurred while logging out");
  });
}


//signup loading dispatching function
export const signup_loading = () => ({
  type: prototype.SIGNUP_LOADING,
});

// login failed dispatching function
export const signup_failed = (response) => ({
  type: prototype.SIGNUP_FAILED,
  payload: response
});

//login dispatching function
export const signup_success = (response) => ({
  type: prototype.SIGNUP_USER,
  payload: response
});

// signup function
// cred means the credentials for signing in (username, passowrd, acctType-> official or client)

export const signUpFunction = (cred) => async (dispatch) => {
 // upon calling this fuction first dispatch a loading status into the store
 dispatch(signup_loading(true));
 const mail = cred.username.trim();
 const pass = cred.password.trim();
 const obj = {
  email: mail,
  password: pass,
  AcctType: cred.AcctType
 }
 console.log(obj)
 return await axios.post(baseURL + '/api/users/signup', obj, {
  headers: {
    "Content-Type": "application/json"
  }
 })
 .then(resp => {
  console.log("signing in resp", resp)
  if (resp.data.success === true) {
    // store the authentication token value inside the localstorage got he browser.
    dispatch(signup_success(resp.data));
  }
 }).catch(err => {
  console.log("This error occurred while signing in", err);
  dispatch(signup_failed(err.response.data.message));
 })
}


// google auth section for both user and officials

export const userGoogleAuth = () => async (dispatch) => {
  // open the auth route
  window.open(baseURL + '/api/auth/google', "_self")
}

// official google auth function

export const officialGoogleAuth = () => async (dispatch) => {
  // open the auth route
  window.open(baseURL + '/api/auth/google2', "_self")
}

// call this funcion to get signed in user authorization token

export const googleSuccess = (token) => async (dispatch) => {
  dispatch(login_success({profile_status: token}));
}

// linkedin auth section for both user and officials

export const userLinkedinAuth = () => async (dispatch) => {
  // open the auth route
  window.open(baseURL + '/api/auth/linkedin', "_self")
}

// official google auth function

export const officialLinkedinAuth = () => async (dispatch) => {
  // open the auth route
  window.open(baseURL + '/api/auth/linkedin2', "_self")
}

// cv section
export const cv_loading = () => ({
  type: prototype.CV_LOADING
});

export const cv_failed = (response) => ({
  type: prototype.GENERATING_CV_FAILED,
  payload: response
});

export const cv_success = (response) => ({
  type: prototype.CV_GENERATED_SUCCESSFULLY,
  payload: response
});


// default credentials
// on clickng Done btn, call this function here.
export const return_CV_state_back_to_null = () => (dispatch) => {
  dispatch(cv_loading(true));
  dispatch(existing_resume_loading(true));
  dispatch(cv_id_loading(true));
}

export const Personal_CV_state_back_to_null = () => (dispatch) => {
  dispatch(cv_loading(true));
}

export const spanish_loading = () => ({
  type: prototype.SPANISH_LOADING
});

export const spanish_success = (spanish) => ({
  type: prototype.SPANISH,
  payload: spanish
});

export const dispatchSpanish = (arg) => async (dispatch) => {
  dispatch(spanish_loading(true));
  dispatch(spanish_success(arg));
}

export const Professional_summary_loading = () => ({
  type: prototype.PROFESSIONAL_SUMMMARY_LOADING
})

export const clearPS = () => (dispatch) => {
  dispatch(Professional_summary_loading(true));
}
export const Professional_summary = (summary) => ({
  type: prototype.PROFESSIONAL_SUMMMARY,
  payload: summary
})

// generate professional summary
export const generate_professional_summary = (cred) => async (dispatch) => {
  const exp_to_use = [];

  for (let i = 0; i <= cred.Experience?.length - 1; i++) {
    exp_to_use.push(cred.Experience[i]?.Day_to_day_work);
  }
  const cred_json_exp = cred.Experience;
  console.log("experience JSON", exp_to_use );
  let actual_skill = [];
  if (cred.Technical_skills !== null && cred.Technical_skills !== undefined) {
    if (cred.Technical_skills.length !== 0) {
      for (let i = 0; i <= cred.Technical_skills.length - 1; i++) {
        console.log(typeof cred.Technical_skills[i])
        if (typeof cred.Technical_skills[i] === "object") {
          actual_skill.push(cred.Technical_skills[i]?.value);
        } else if (typeof cred.Technical_skills[i] === 'string') {
          actual_skill.push(cred.Technical_skills[i]);
        }
      }
    } else {
      actual_skill = [];
    }
  } else {
    actual_skill = [];
  }
  const cred_json_tech = cred.Technical_skills;
  console.log("Skills JSON", actual_skill );
  console.log("start skill JSON", cred.Technical_skills );
  
  const cred_json_CvType = JSON.stringify(cred.CvType);
  console.log("Job title JSON", cred_json_CvType );

  const command = `Given the user's experience of '${exp_to_use?.map(element => (element))}', technical skills ${actual_skill?.map(element => (element))}, and desired job type ${cred_json_CvType}, generate a personalized professional summary for a professional resume. The result should be no more than 50 words and formatted in JSON with the key "Summary".`
  const configuration = new Configuration({
		apiKey: "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",
	});

  console.log("COMMAND", command);
  delete configuration.baseOptions.headers['User-Agent'];
	const openai = new OpenAIApi(configuration);
  openai.createChatCompletion({
    model: 'gpt-3.5-turbo',
    messages: [{ role: 'user', content: command}],
    temperature: 0.9
  }).then(resp => {
    const result = resp.data.choices[0].message.content;
    console.log("Professional Summary", result);
    const obj = JSON.parse(result);
    const keys = Object.keys(obj);
    console.log(keys);
    let f_result;
    if (keys[0].slice(0, 1) !== keys[0].slice(0, 1).toUpperCase()) {
      const r = {
        Summary: obj.summary
      }
      f_result = r.Summary
    } else {
      f_result = obj.Summary
    }
    dispatch(Professional_summary(f_result))
  })
}

// generate experience based on provided experience

// individual experience
export const expDetails = (exp) => ({
  type: prototype.INDIVIDUAL_EXPERIENCE,
  payload: exp
})

export const expDetails_error = (error) => ({
  type: prototype.INDIVIDUAL_EXPERIENCE_ERROR,
  payload: error
})

export const expDetails_loading = () => ({
  type: prototype.INDIVIDUAL_EXPERIENCE_LOADING
})

export const cleanEX = () => (dispatch) => {
  dispatch(expDetails_loading(true));
}

export const generate_experience = (cred) => async (dispatch) => {

  const command = `Using the user's experience ${cred.Experience} for a ${cred.CvType} role, generate a concise experience description suitable for a ${cred.CvType} job application. Identify and highlight synergies. The result should be strictly the experience description, without any additional pre-text or post-text, and must not exceed 50 words. If hightlight the experience in bullet format.`
  const configuration = new Configuration({
		apiKey: "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",
	});

  delete configuration.baseOptions.headers['User-Agent'];
	const openai = new OpenAIApi(configuration);
  openai.createChatCompletion({
    model: 'gpt-3.5-turbo',
    messages: [{ role: 'user', content: command}],
    temperature: 0.9
  }).then(resp => {
    const result = resp.data.choices[0].message.content;
    console.log("Generated experience", result);
    dispatch(expDetails(result))
    return result;
  }).catch(err => {
    console.log("experience generation error:", err.message);
    if (err.message == "Network Error" || err.message == "timeout exceeded" || err.message == "Request failed with status code 503" ) {
      dispatch(expDetails_error("Network error"));
    }
  })
}

export const about_loading = () => ({
  type: prototype.ABOUT_LOADING
})

export const about_failed = (cred) => ({
  type: prototype.ABOUT_FAILED,
  payload: cred
})

export const about_success = (cred) => ({
  type: prototype.ABOUT,
  payload: cred
})

export const generate_employer_about = (cred) => async (dispatch) => {
  dispatch(about_loading(true));
  const command = `Using the user's company information ${cred.about}, generate a standard introduction of the company ${cred.name} based on ${cred.about} .The result must not exceed 70 words.`
  const configuration = new Configuration({
		apiKey: "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",
	});

  delete configuration.baseOptions.headers['User-Agent'];
	const openai = new OpenAIApi(configuration);
  openai.createChatCompletion({
    model: 'gpt-3.5-turbo',
    messages: [{ role: 'user', content: command}],
    temperature: 0.9
  }).then(resp => {
    const result = resp.data.choices[0].message.content;
    console.log("Generated employer about", result);
    dispatch(about_success(result))
    return result;
  }).catch(err => {
    console.log("experience generation error:", err.message);
    if (err.message == "Network Error" || err.message == "timeout exceeded" || err.message == "Request failed with status code 503" ) {
      dispatch(about_failed("Network error"));
    }
  })
}

export const lang_type = (cred) => ({
  type: prototype.LANG_TYPE_S,
  payload: cred
})




export const generate_my_cv = (cred) => async (dispatch) => {
  dispatch(cv_loading(true));
  console.log("cred", cred);
  const final_obj = { ...cred, Lang: [{lang: "English"}]}
  dispatch(cv_success(final_obj));
/*   if (cred.Lang[0].lang == 'English') {
    cred.Lang[0].lang = 'English';
  } else if (cred.Lang[0].lang == 'Spanish') {
    cred.Lang[0].lang = "Latin American Spanish";
  }
  const cred = {
    Lang: [{lang: "spanish"}]
  }
    const valueToBeMapped = { "Fullname": cred.Fullname, "Address": cred.Address, "Email": cred.Email, "Phone_number": cred.Phone_number, "Lang": cred.Lang, "Reference": cred.Reference, "Language": cred.Language, "Website": cred.Website, "Linkedin": cred.Linkedin };

    const detailsToFilter = { ...cred};
    delete detailsToFilter.Fullname;
    delete detailsToFilter.Address;
    delete detailsToFilter.Email;
    delete detailsToFilter.Phone_number;
    delete detailsToFilter.Lang;
    delete detailsToFilter.Reference;
    delete detailsToFilter.Language;
    delete detailsToFilter.Website;
    delete detailsToFilter.Linkedin;
  
    const userInformation = `${JSON.stringify(detailsToFilter)}`;
   */
/*     const command = `Strictly examine and convert all values of this object ${userInformation} into ${cred.Lang[0].lang}. All keys should be in English while values should be changed to ${cred.Lang[0].lang}. Do not truncated "Experience" array or any array for brevity but strictly return all the experiences array, make sure to return everything.
    Return the response or result exactly in object-readable format following this key:
    "Professional_summary, School, Degree, Course, Course should be a string inside of Education object array and not an array, Start_date, End_date, Interest, CvType, Award, Education, Experience, Technical_skills, Personal_skills"
    Education, Experience, Technical_skills, Personal_skills, Award should all be in an array.
     
    ` */
  
/*     const configuration = new Configuration({
      apiKey: "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",
    });

    delete configuration.baseOptions.headers['User-Agent'];
    const openai = new OpenAIApi(configuration);
    openai.createChatCompletion({
      model: 'gpt-3.5-turbo',
      messages: [{ role: 'user', content: command}],
      temperature: 0
    }).then(resp => {
      const result = resp.data.choices[0].message.content;
      console.log("result", result);
      let r1 = result.replace('\n', "");
      console.log("r1", r1)
      console.log("Strip!!!", r1.slice(r1.indexOf('{'), r1.lastIndexOf('}') + 1));
      const r2 = r1.slice(r1.indexOf('{'), r1.lastIndexOf('}') + 1);
      const final_result = {...valueToBeMapped, ...JSON.parse(r2)};
      console.log("keys after parsing", Object.keys(final_result));
  
      console.log("final_result", final_result);
      dispatch(cv_success(final_result)); */




      /* if (result.includes("already in English")) {
        dispatch(cv_success(cred));
      } else {
        const final_result = {...valueToBeMapped, ...JSON.parse(r2)};
        console.log("keys after parsing", Object.keys(final_result));
    
        console.log("final_result", final_result);
        dispatch(cv_success(final_result));
      } */
    // })

  /* 
  const valueToBeMapped = { "Fullname": cred.Fullname, "Address": cred.Address, "Email": cred.Email, "Phone_number": cred.Phone_number, "Lang": cred.Lang, "Reference": cred.Reference, "Language": cred.Language, "Website": cred.Website, "Linkedin": cred.Linkedin };
  const detailsToFilter = { ...cred}; */
  //  created a new object and delete or remove users name and address to protect users core/vital info.
/*   delete detailsToFilter.Fullname;
  delete detailsToFilter.Address;
  delete detailsToFilter.Email;
  delete detailsToFilter.Phone_number;
  delete detailsToFilter.Lang;
  delete detailsToFilter.Reference;
  delete detailsToFilter.Language;
  delete detailsToFilter.Website;
  delete detailsToFilter.Linkedin;
 */
  /* console.log("detailsToFilter", detailsToFilter); */

  /* const configuration = new Configuration({
		apiKey: "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",
	});

  delete configuration.baseOptions.headers['User-Agent'];
	const openai = new OpenAIApi(configuration);
  const userInformation = `${JSON.stringify(detailsToFilter)}`;
 */
  // Create a command to generate a professional resume
  /* const command = `You are an HR career specialist with experience in resume creation and improvement. Your goal is to Create a world class comprehensive resume by capturing the candidate's information provided here '${userInformation}' and then highlighting their skills and experiences to match this job position '${cred.CvType}' by Filling in missing or vague details with industry-standard skills to improve job descriptions and responsibilities. Use a clear structure, formal language, and quantify achievements. Optimize for ATS and tailor the resume to the target -interest/job/industry. Check for errors, grammar, spelling, and punctuation. Arrange Experienc and Education based on the standard and professional date arrangment. Please all keys should be in English and values should be changed to ${cred.Lang[0].lang}.
  Abbreviate all months.
  Return the response or result exactly in object-readable format following this key:
  "Professional_summary, School, Degree, Course, Course should be a string inside of Education object array and not an array, Start_date, End_date, Volunteer_Org, Membership_level, Volunteer_join_date, Volunteer_end_date, Interest, CvType, Award, Education, Experience, Technical_skills, Personal_skills"
  Education, Experience, Technical_skills, Personal_skills, Award, Reference should all be in an array.
  Do not add any text before or after the object result. Only return the object result itself.`;
 */
  /*
 Create a world class comprehensive resume by capturing the candidate's information provided here '${JSON.stringify(userInformation)}' and then highlighting their skills and experiences by Filling in missing or vague details with industry-standard skills to improve job descriptions and responsibilities. Use a clear structure, formal language, and quantify achievements. Optimize for ATS and tailor the resume to the target -interest/job/industry. Check for errors, grammar, spelling, and punctuation. */

  /* openai.createChatCompletion({
    model: 'gpt-3.5-turbo',
    messages: [{ role: 'user', content: command}],
    temperature: 0.8
  })
  .then(resp => {
    const result = resp.data.choices[0].message.content;
    console.log("result", result);
    let r1 = result.replace('\n', "");
    console.log("r1", r1)
    const final_result = {...valueToBeMapped, ...JSON.parse(r1)};
    console.log("keys after parsing", Object.keys(final_result));

    console.log("final_result", final_result);
    dispatch(cv_success(final_result)); 
    window.open(baseURL1 + "/allCv")
  }).catch(err => {
    console.log("typeof error", typeof err);
    let errArr = err.message.split(" ");
    console.log("errArr", errArr);
    let errMess;
    if (errArr[0] === "Unterminated" && errArr[1] === "string") {
      errMess = "The content your are trying to process to generate your resume is too large, kindly reduce your experience or anything you can. Thanks"
    } else if (errArr[0] === "Unexpected" && errArr[1] === 'token') {
      errMess = "An error occurred. refresh the page and try again."
    } else if (errArr[0] === "Request" && errArr[1] === "failed") {
      errMess = err.message;
    } else if (errArr[0] === "Failed" && errArr[1] === "to" && errArr[2] === "fetch") {
      errMess = "Session expired, login again."
      alert("Session expired, login again.");
      window.open(baseURL1 + "/login");
    } */

/*     console.log("can't process first command, chatGPT error", err);
    console.log("error while processing existing CVs", err);
    dispatch(cv_failed(errMess));
  }) */
}

// dispatch the id selected to store
export const cv_id_loading = () => ({
  type: prototype.CV_ID_LOADING
})

export const dispatch_cv_id = (id) => ({
  type: prototype.CV_ID,
  payload: id
})

export const Cv_id = (id) => (dispatch) => {
  dispatch(dispatch_cv_id(id.id));
}

export const dispatch_cv_pics = (pics) => ({
  type: prototype.CV_PICS,
  payload: pics
})

// Existing resume section


export const user_CV_state_back_to_null = () => (dispatch) => {
  dispatch(existing_resume_loading(true));
}


export const existing_resume_loading = () => ({
  type: prototype.EXISTING_CV_LOADING
});
export const existing_resume_failed = (response) => ({
  type: prototype.GENERATING_EXISTING_CV_FAILED,
  payload: response
});
export const existing_resume = (response) => ({
  type: prototype.EXISTING_CV_GENERATED_SUCCESSFULLY,
  payload: response
});

const commandFunction = (text) => {

  const command = `You are an HR career specialist with experience in resume creation and improvement. Your goal is to capture candidate information provided here '${text}' and divide it into the following keys: "Fullname, Address, Email, Phone_number, Professional_summary, Linkedin, Website, School, Degree, Start_date, End_date,  Volunteer_Org, Membership_level, Volunteer_join_date, Volunteer_end_date, Reference_person_name, How_do_i_know_this_person, Referencee_job_title, Reference_email, Reference_phone_number, Language, Language_speaking_rate, Interest, Award, Award_name, Award_giver, Award_year, Education, Experience, Technical_skills, Personal_skills, Education should be divided into the following key "School, Degree, End_date, Start_date" and Experience should be divided into the following key "Where_i_worked, Where_i_worked_location, My_job_title, Work_start_date, Work_end_date, Day_to_day_work" only, Education (array), Experience (array), Award (array), and Technical_skills (array), Personal_skills(array)' respectively. Remove all nested keys inside Technical_skills and Personal_skills, only put the values in an Technical _skills array and Personal_skills array. Strictly follow each key above"

  if any of the text provided here ${text} is in bullet or numbering form, return them in that same form.
   Abbreviate all months.
   Arrange the Experience and Education in the standard and professional resume date arrangement.
   Check the content for grammar, spelling, and punctuation errors, and ensure the final resume is error-free.
   if adjustment is needed in the course of parsing the response, make the adjustment and return the response or result exactly in object-readable format following this key:
   If the text is too long to process all, then provide the results within your character limit capabilities.
   Do anything necessary to avoid getting this kind of error 'chatGPT error SyntaxError: Unterminated string in JSON' and ensure to always close any open parenthesis '()', square bracket '[]' and curly brackets '{}' before returning the result or response.
   Do not add any text before or after the object result. Only return the object result itself.
 `
    return command;
}


export const existing_resume_features = (arg) => async (dispatch) => {
  dispatch(existing_resume_loading(true));
  const bearer = localStorage.getItem("token");
  return fetch(baseURL + "/api/extract/existingPDF", {
    method: "POST",
    body: arg,
    headers: {
      "Authorization": "Bearer " + bearer
    }
  }).then(resp => resp.json())
  .then(resp => {
    const specialCharacters = /[.*+?^${}()|[\]\\]/g;
    const escapeChar = '\\$&';
    const text = resp.data.replace(/\n\s*\n/g, '\n'); // remove new line and excess spaces.
    const final_text = text.replace(specialCharacters, escapeChar);
    let first_text, second_text;
    console.log("length of text", final_text.length);
    
    if (final_text.length > 8000) {
      const errMess = "PDF too large, please kindly upload another resume or proceed to fill the form ahead";
      dispatch(existing_resume_failed(errMess));
    } else {
    if (final_text.length > 4000 && final_text.length < 8000) {
        let text_half_length = final_text.length / 2;
        first_text = final_text.slice(0, text_half_length);
        second_text = final_text.slice(text_half_length, final_text.length);
    }
  
      console.log("final_text", final_text);
  
      const configuration = new Configuration({
        apiKey: "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",
      });

      delete configuration.baseOptions.headers['User-Agent'];
      const openai = new OpenAIApi(configuration);
      // command goes here
      if ( final_text.length <= 4000) {
        const command = commandFunction(final_text);
        openai.createChatCompletion({
          model: "gpt-3.5-turbo",
          messages: [{role: "user", content: command}],
          temperature: 0.8
        }).then(response => {
            console.log("response", response.data.choices[0].message.content);
            let result = response.data.choices[0].message.content;
            let r3 = result.replace("\n\n", "");
            let r2 = r3.replace("\n", "");
            let strip = r2.slice(r2.indexOf('{'), r2.lastIndexOf('}') + 1);
            let r1 = JSON.parse(strip);
            console.log("result", result);
            console.log("r1", r1);
    
            // get edu_length
            if (r1.School !== null && r1.School !== undefined) {
              if (Array.isArray(r1.School) === true) {
                for (let i = 0; i <= r1.School.length - 1; i++) {
                  if (typeof r1.School[i] !== "string" && typeof r1.School[i] === 'object') {
                    r1.School[i].key = i;
                  }
                }
              }
            }
    
            if (r1.Education !== null && r1.Education !== undefined) {
              if (Array.isArray(r1.Education) === true) {
                for (let i = 0; i <= r1.Education.length - 1; i++) {
                  r1.Education[i].key = i;
                }
              }
            }
    
            // get the exp_length
            if (r1.Experience !== null && r1.Experience !== undefined) {
              if (Array.isArray(r1.Experience) === true) {
                for (let i = 0; i <= r1.Experience.length - 1; i++) {
                  r1.Experience[i].key = i;
                }
              }
            }

            // test if Technical_skills is an object
            if (r1.Technical_skills !== null && r1.Technical_skills !== undefined) {
              if (Array.isArray(r1.Technical_skills) == true && typeof r1.Technical_skills[0] === "string") {
                r1.Technical_skills = r1.Technical_skills;
              } else {
                let skills = [];
                for (let key in r1.Technical_skills) {
                  if (typeof r1.Technical_skills[key] === "string") {
                    skills.push(r1.Technical_skills[key]);
                  } else if (Array.isArray(r1.Technical_skills[key]) === true) {
                    skills = [ ...skills, ...r1.Technical_skills[key]];
                  } else {
                    skills = [ ...skills];
                  }
                }
                r1.Technical_skills = skills;
              }
            }
    
            // after getting the values, then it's time to create their key respectively;
            // lets fix school first
    
            dispatch(existing_resume(r1));
            window.open(baseURL1 + "/generateCV", "_self");
          }).catch(err => {
            let errMess;
            if (err == "Network Error") {
              errMess = "Network Error";
            } else {
              errMess = "Failed to extract your information from the CV you provided. Try again by uploading it again or proceed to fill the form ahead. Thanks"
            }
            console.log("can't process first command, chatGPT error", err);
            console.log("error while processing existing CVs", err);
            dispatch(existing_resume_failed(errMess))
          })
      } else {

        let final_text_object = {};
        const command1 = commandFunction(first_text);
        openai.createChatCompletion({
          model: "gpt-4",
          messages: [{role: "user", content: command1}],
          temperature: 0.8
        }).then(response => {
          console.log("response", response.data.choices[0].message.content);
          let result1 = response.data.choices[0].message.content;
          let r3 = result1.replace("\n\n", "");
          let r2 = r3.replace("\n", "");
          let strip = r2.slice(r2.indexOf('{'), r2.lastIndexOf('}') + 1);
          let r1 = JSON.parse(strip);
          console.log("result", result1);
          console.log("r1", r1);

          const command2 = commandFunction(second_text);
          openai.createChatCompletion({
            model: "gpt-4",
            messages: [{role: "user", content: command2}],
            temperature: 0.8
          }).then(respo => {
            console.log("response1", respo.data.choices[0].message.content);
            let result2 = respo.data.choices[0].message.content;
            let r6 = result2.replace("\n\n", "");
            let r5 = r6.replace("\n", "");
            let strip1 = r5.slice(r5.indexOf('{'), r5.lastIndexOf('}') + 1);
            let r4 = JSON.parse(strip1);
            console.log("result2", result2);
            console.log("r4", r4);
    
            if ( r1.Education !== null && r1.Education !== undefined) {
              if ( r4.Education !== null && r4.Education !== undefined) {
                if (Array.isArray(r4.Education) === true) {
                  for ( let i = 0; i <= r4.Education.length - 1; i++ ) {
                    // push each object into r1
                    r1.Education.push(r4.Education[i]);
                  }
                }
              }
            }
  
            if (r1.School !== null && r1.School !== undefined) {
              if (r4.School !== undefined && r4.School !== null) {
                if (Array.isArray(r4.School) === true) {
                  for ( let i = 0; i <= r4.School.length - 1; i++ ) {
                    if (typeof r4.School[i] !== "string" && typeof r4.School[i] === 'object') {
                      r4.School[i].key = i;
                      // push each object into r1
                      r1.School.push(r4.School[i]);
                    }
                  }
                }
              }

              /* if (Array.isArray(r1.School) === true) {
                for (let i = 0; i <= r1.School.length - 1; i++) {
                  if (typeof r1.School[i] !== "string" && typeof r1.School[i] === 'object') {
                    r1.School[i].key = i;
                  }
                }
              } */
            }

/*             if ( r1.School !== null && r1.School !== undefined) {
              if (r4.School !== undefined && r4.School !== null) {
                if (Array.isArray(r4.School) === true) {
                  for ( let i = 0; i <= r4.School.length - 1; i++ ) {
                    // push each object into r1
                    r1.School.push(r4.School[i]);
                  }
                }
              }
            } */
            
            if (r1.Experience !== null && r1.Experience !== undefined) {
              if (r4.Experience !== null && r4.Experience !== undefined) {
                if (Array.isArray(r4.Experience) === true) {
                  for ( let i = 0; i <= r4.Experience.length - 1; i++ ) {
                    // push each object into r1
                    r1.Experience.push(r4.Experience[i]);
                  }
                }
              }
            }

            if ( r1.Technical_skills !== null && r1.Technical_skills !== undefined) {
              if (r4.Technical_skills !== null && r4.Technical_skills !== undefined) {
                if (Array.isArray(r4.Technical_skills) === true) {
                  for ( let i = 0; i <= r4.Technical_skills.length - 1; i++ ) {
                    r1.Technical_skills.push(r4.Technical_skills[i]);
                  }
                }
              }
            }
  
            if (r1.Personal_skills !== null && r1.Personal_skills !== undefined) {
              if (r4.Personal_skills !== null && r4.Personal_skills !== undefined) {
                if (Array.isArray(r4.Personal_skills) === true) {
                  for ( let i = 0; i <= r4.Personal_skills.length - 1; i++ ) {
                    r1.Personal_skills.push(r4.Personal_skills[i]);
                  }
                }
              }
            }
            
            if ( r1.Reference !== null && r1.Reference !== undefined) {
              if (r4.Reference !== null && r4.Reference !== undefined) {
                if (Array.isArray(r4.Reference) === true) {
                  for ( let i = 0; i <= r4.Reference.length - 1; i++ ) {
                    r1.Reference.push(r4.Reference[i]);
                  }
                }
              }
            }
  
            if ( r1.Award !== null && r1.Award !== undefined) {
              if (r4.Award !== null && r4.Award !== undefined) {
                if (Array.isArray(r4.Award) === true) {
                  for ( let i = 0; i <= r4.Award.length - 1; i++ ) {
                    r1.Award.push(r4.Award[i]);
                  }
                }
              }
            }
            const f_r1 = { ...r1 };
  
            console.log("f_r1", f_r1);
            if (f_r1.School !== null && f_r1.School !== undefined) {
              if (Array.isArray(f_r1.School) === true) {
                for (let i = 0; i <= f_r1.School.length - 1; i++) {
                  f_r1.School[i].key = i;
                }
              }
            }
    
            if (f_r1.Education !== null && f_r1.Education !== undefined) {
              if (Array.isArray(f_r1.Education) === true) {
                for (let i = 0; i <= f_r1.Education.length - 1; i++) {
                  f_r1.Education[i].key = i;
                }
              }
            }


            if (f_r1.Experience !== null && f_r1.Experience !== undefined) {
              if (Array.isArray(f_r1.Experience) === true) {
                for (let i = 0; i <= f_r1.Experience.length - 1; i++) {
                  f_r1.Experience[i].key = i;
                }
              }
            }
  
            dispatch(existing_resume(f_r1));
            window.open(baseURL1 + "/generateCV", "_self");
          }).catch(err => {
            let errMess;
            if (err === "Error: Network Error") {
              errMess = "Network Error";
            } else {
              errMess = "Failed to extract your information from the CV you provided. Try again by uploading it again or proceed to fill the form ahead. Thanks"
            }
            console.log("can't process first command, chatGPT error", err);
            console.log("error while processing existing CVs", err);
            dispatch(existing_resume_failed(errMess))
          })
        }).catch(err => {
          let errMess;
          if (err === "Error: Network Error") {
            errMess = "Network Error";
          } else {
            errMess = "Failed to extract your information from the CV you provided. Try again by uploading it again or proceed to fill the form ahead. Thanks"
          }
          console.log("can't process first command, chatGPT error", err);
          console.log("error while processing existing CVs", err);
          dispatch(existing_resume_failed(errMess))
        })
      }
    }
  }).catch(err => {
    const errArr = err.message.split(" ");
    console.log("err mes", err.message)
    let errMess;
    if (err === "Error: Network Error") {
      errMess = "Network Error";
    } else {
      errMess = "Failed to extract your information from the CV you provided. Try again by uploading it again or proceed to fill the form ahead. Thanks"
    }

    if (errArr[0] === "Failed" && errArr[1] === "to" && errArr[2] === "fetch") {
      errMess = "Session expired, login again."
      alert("Session expired, login again.");
      window.open(baseURL1 + "/login");
    }
    console.log("can't process first command, chatGPT error", err);
    console.log("error while processing existing CVs", err);
    dispatch(existing_resume_failed(errMess))
  })
}


/* const r1 = resp.text.replace("\n", "");
console.log("r1", r1)
const r2 = JSON.parse(r1);
console.log("r2", r2);
if (typeof r2 === 'object') {
  dispatch(existing_resume(r2));
} else {
  dispatch(existing_resume_failed("Failed to extract your information from the CV you provided. Try again by uploading it again or proceed to fill the form ahead. Thanks"))
} */


// get user's name to be used in dashboard

export const userNameInfo_loading = () => ({
  type: prototype.LOADING_USER_NAME
})

export const userInfo = (response) => ({
  type: prototype.USER_NAME_DB,
  payload: response
})

export const userName_from_db = (params) => async (dispatch) => {
  dispatch(userNameInfo_loading(true));

  return fetch(baseURL + "/api/users/myInfo", {
    headers: {
      "Authorization": "Bearer " + params
    }
  }).then(resp => resp.json())
  .then(resp => {
    console.log("user information", resp)
    if (resp.success === true) {
      dispatch(userInfo(resp.data));
    }
  }).catch(err => {
    console.log("getting user name error", err);
  })
}


export const save_last_resume = (response) => ({
  type: prototype.LAST_RESUME,
  payload: response
})

export const lastResme = (cred) => async (dispatch) => {
  dispatch(save_last_resume(cred));
}

export const getting_cv_details_loading = () => ({
  type: prototype.GETTING_CV_LOADING
});

export const getting_failed = (response) => ({
  type: prototype.GETTING_CV_FAILED,
  payload: response
});

export const getting_successful = (response) => ({
  type: prototype.GETTING_CV_SUCCESS,
  payload: response
})


export const getAllMyCv = (token) => async (dispatch) => {
  dispatch(getting_cv_details_loading(true));

  return fetch(baseURL + "/api/resumeUpload/mycv", {
    headers: {
      "Content-Type": "application/json",
      "Authorization": "Bearer " + token
    }
  }).then(resp => resp.json())
  .then(resp => {
    if (resp.success === true) {
      dispatch(getting_successful(resp.data));
    } else {
      dispatch(getting_failed(resp.status));
    }
  }).catch(err => {
    /* console.log("error while fetching cvs from database");    
    const errArr = err.message.split(" ");
    console.log("err mes", err.message)
    if (errArr[0] === "Failed" && errArr[1] === "to" && errArr[2] === "fetch") {
      alert("Session expired, login again.");
      window.open(baseURL1 + "/login");
    } else {
      dispatch(getting_failed(err));
    } */

    dispatch(getting_failed(err));
  });
}

// empployer profile


export const getting_employer_profile_loading = () => ({
  type: prototype.GET_EMPLOYER_PROFILE_LOADING
});

export const getting_employer_profile_failed = (response) => ({
  type: prototype.GET_EMPLOYER_PROFILE_FAILED,
  payload: response
});

export const getting_employer_profile_successful = (response) => ({
  type: prototype.GET_EMPLOYER_PROFILE_SUCCESS,
  payload: response
})

export const getEmployerProfile = () => async (dispatch) => {
  dispatch(getting_employer_profile_loading(true));
  return fetch(baseURL + "/api/employer/my_employee_profile", {
    headers: {
      "Content-Type": "application/json",
      "Authorization": "Bearer " + localStorage.getItem('token')
    }
  }).then(resp => resp.json())
  .then(resp => {
    console.log("profile resp", resp)
    
    if (resp.success === true) {
      if (resp.data === null) {
        const response = []
        dispatch(getting_profile_successful(response));
      } else {
        dispatch(getting_employer_profile_successful(resp.data));
      }
    } else {
      dispatch(getting_employer_profile_failed(resp.status));
    }
  }).catch(err => {
    console.log("error while fetching cvs from database", err);
      dispatch(getting_employer_profile_failed(err));
  });
}

// save link
export const save_link_loading = (response) => ({
  type: prototype.SAVE_LINK_LOADING,
});

export const savelink = (response) => ({
  type: prototype.SAVE_LINK,
  payload: response
});

export const getting_profile_profile_loading = () => ({
  type: prototype.GET_PUBLIC_PROFILE_LOADING
});

export const getting_public_profile_failed = (response) => ({
  type: prototype.GET_PUBLIC_PROFILE_FAILED,
  payload: response
});

export const getting_public_profile_successful = (response) => ({
  type: prototype.GET_PUBLIC_PROFILE_SUCCESS,
  payload: response
})


export const employeePublicView = (profile_id) => async (dispatch) => {
  dispatch(getting_profile_profile_loading(true));
  return fetch(baseURL + `/api/users/profile/${profile_id}`, {
    headers: {
      "Content-Type": "application/json",
      "Authorization": "Bearer " + localStorage.getItem('token')
    }
  }).then(resp => resp.json())
  .then(resp => {
    console.log("profile resp", resp)
    
    if (resp.success === true) {
      if (resp.data === null) {
        const response = []
        dispatch(getting_public_profile_successful(response));
      } else {
        dispatch(getting_public_profile_successful(resp.data));
      }
    } else {
      dispatch(getting_public_profile_failed(resp.message));
    }
  }).catch(err => {
    console.log("error while fetching cvs from database", err);
      dispatch(getting_public_profile_failed(err));
  });
}

export const getting_profile_loading = () => ({
  type: prototype.GET_PROFILE_LOADING
});

export const getting_profile_failed = (response) => ({
  type: prototype.GET_PROFILE_FAILED,
  payload: response
});

export const getting_profile_successful = (response) => ({
  type: prototype.GET_PROFILE_SUCCESS,
  payload: response
})

export const getProfile = (params) => async (dispatch) => {
  dispatch(getting_profile_loading(true));
  return fetch(baseURL + "/api/client/myprofile", {
    headers: {
      "Content-Type": "application/json",
      "Authorization": "Bearer " + params
    }
  }).then(resp => resp.json())
  .then(resp => {
    console.log("profile resp", resp)
    
    if (resp.success === true) {
      if (resp.data === null) {
        const response = []
        dispatch(getting_profile_successful(response));
      } else {
        dispatch(getting_profile_successful(resp.data));
      }
    } else {
      dispatch(getting_profile_failed(resp.status));
    }
  }).catch(err => {
    console.log("error while fetching cvs from database", err);
      dispatch(getting_profile_failed(err));
  });
}

export const uppdateYOF = (yof) => async (dispatch) => {
  // make an update api call
  const obj = {
    Years_of_experience: yof
  }
  fetch(baseURL + "/api/client/updateyearofexperience", {
    method: "PUT",
    body: JSON.stringify(obj),
    headers: {
      "Content-Type": "application/json",
      "Authorization": "Bearer " + localStorage.getItem("token")
    },
  }).then(resp => resp.json())
  .then(resp => {
    if (resp.success === true) {
      dispatch(getting_profile_successful(resp.data));
    }
  }).catch(err => console.log("Update failed"));
}

export const uppdateJobTitle = (title) => async (dispatch) => {
  // make an update api call
  const obj = {
    Job_title: title
  }
  fetch(baseURL + "/api/client/updatejobtitle", {
    
    method: "PUT",
    body: JSON.stringify(obj),
    headers: {
      "Content-Type": "application/json",
      "Authorization": "Bearer " + localStorage.getItem("token")
    },
  }).then(resp => resp.json())
  .then(resp => {
    if (resp.success === true) {
      dispatch(getting_profile_successful(resp.data));
    }
  }).catch(err => console.log("Update failed"));
}

export const uppdateAbout = (about) => async (dispatch) => {
  // make an update api call
  const obj = {
    About: about
  }
  return fetch(baseURL + "/api/client/updateabout", {
    
    method: "PUT",
    body: JSON.stringify(obj),
    headers: {
      "Content-Type": "application/json",
      "Authorization": "Bearer " + localStorage.getItem("token")
    },
  }).then(resp => resp.json())
  .then(resp => {
    if (resp.success === true) {
      dispatch(getting_profile_successful(resp.data));
    }
  }).catch(err => console.log("Update failed"));
}

export const uppdateInterest = (interest) => async (dispatch) => {
  // make an update api call
  const obj = {
    Interest: interest
  }
  return fetch(baseURL + "/api/client/updateinterest", {
    
    method: "PUT",
    body: JSON.stringify(obj),
    headers: {
      "Content-Type": "application/json",
      "Authorization": "Bearer " + localStorage.getItem("token")
    },
  }).then(resp => resp.json())
  .then(resp => {
    if (resp.success === true) {
      dispatch(getting_profile_successful(resp.data));
    }
  }).catch(err => console.log("Update failed"));
}


export const updateExperience = (experience) => async (dispatch) => {
  // make an update api call
  console.log("workkkkk", experience)
  const obj = {
    Experience: experience
  }
  return fetch(baseURL + "/api/client/updateexperience", {
    
    method: "PUT",
    body: JSON.stringify(obj),
    headers: {
      "Content-Type": "application/json",
      "Authorization": "Bearer " + localStorage.getItem("token")
    },
  }).then(resp => resp.json())
  .then(resp => {
    if (resp.success === true) {
      dispatch(getting_profile_successful(resp.data));
    }
  }).catch(err => console.log("Update failed"));
}

export const updateEducation = (education) => async (dispatch) => {
  // make an update api call
  const obj = {
    Education: education
  }
  return fetch(baseURL + "/api/client/updateeducation", {
    
    method: "PUT",
    body: JSON.stringify(obj),
    headers: {
      "Content-Type": "application/json",
      "Authorization": "Bearer " + localStorage.getItem("token")
    },
  }).then(resp => resp.json())
  .then(resp => {
    if (resp.success === true) {
      dispatch(getting_profile_successful(resp.data));
    }
  }).catch(err => console.log("Update failed"));
}

export const updateRef = (reference) => async (dispatch) => {
  // make an update api call
  const obj = {
    Reference: reference
  }
  return fetch(baseURL + "/api/client/updatereference", {
    
    method: "PUT",
    body: JSON.stringify(obj),
    headers: {
      "Content-Type": "application/json",
      "Authorization": "Bearer " + localStorage.getItem("token")
    },
  }).then(resp => resp.json())
  .then(resp => {
    if (resp.success === true) {
      dispatch(getting_profile_successful(resp.data));
    }
  }).catch(err => console.log("Update failed"));
}

export const updateSkills = (skills) => async (dispatch) => {
  // make an update api call
  const obj = {
    Skills: skills
  }
  return fetch(baseURL + "/api/client/updateskills", {
    
    method: "PUT",
    body: JSON.stringify(obj),
    headers: {
      "Content-Type": "application/json",
      "Authorization": "Bearer " + localStorage.getItem("token")
    },
  }).then(resp => resp.json())
  .then(resp => {
    if (resp.success === true) {
      dispatch(getting_profile_successful(resp.data));
    }
  }).catch(err => console.log("Update failed"));
}

export const updateSoft_skills = (soft_skills) => async (dispatch) => {
  // make an update api call
  const obj = {
    Soft_skills: soft_skills
  }
  return fetch(baseURL + "/api/client/updatesoftskills", {
    method: "PUT",
    body: JSON.stringify(obj),
    headers: {
      "Content-Type": "application/json",
      "Authorization": "Bearer " + localStorage.getItem("token")
    },
  }).then(resp => resp.json())
  .then(resp => {
    if (resp.success === true) {
      dispatch(getting_profile_successful(resp.data));
    }
  }).catch(err => console.log("Update failed"));
}


// function to save users cv details to the backend
export const saveCvDetails = (details, id, clientSecret ) => async (dispatch) => {
  dispatch(getting_profile_loading(true));
  console.log("posting users resume details");
  const token = localStorage.getItem('token');
  // do something here with the details argument.
  const value = {...details, pdfId: id, secret: clientSecret}
  return fetch(baseURL + "/api/resumeUpload/saveCV", {
    method: "POST",
    body: JSON.stringify(value),
    headers: {
      "Content-Type": "application/json",
      "Authorization": "Bearer " + token
    }
  }).then(resp => resp.json())
  .then(resp => {
    console.log("CV successfully saved", resp);
    if (resp.data.employee !== null) {
      dispatch(getting_profile_successful(resp.data.employee));
      dispatch(login_success({profile_status: true, AcctType: "Client"})); // login to indicate that the user now have a profile.
    }
    if (resp.userResume !== null && resp.userResume !== undefined) {
      dispatch(getting_successful(resp.userResume));
    } else {
      dispatch(getting_successful([]));
    }
  }).catch(err => {
    throw err;
  });
}

export const postUserProfile = (token) => async (dispatch) => {

  return fetch(baseURL + "/api/profile/myprofile", {
    method: 'POST',
    headers: {
      "Content-Type": "application/json",
      "Authorization": "Bearer " + token
    }
  }).then(resp => resp.json())
  .then(resp => {
    console.log("User profile created", resp);
  }).catch(err => {
    console.log("cannaot create user profile");
  });
}

// forget password section

export const v_mail_loading = () => ({
  type: prototype.V_MAIL_LOADING
});

export const v_mail_failed = (response) => ({
  type: prototype.V_MAIL_FAILED,
  payload: response
});

export const v_mail_success = () => ({
  type: prototype.V_MAIL_SUCCESS
})


export const sendMail = (mail) => async (dispatch) => {
  dispatch(v_mail_loading(true));

  const obj = {
    username: mail
  }
  fetch(baseURL + "/api/users/yourMail", {
    method: "POST",
    body: JSON.stringify(obj),
    headers: {
      "Content-Type": "application/json"
    }
  }).then(resp => resp.json())
  .then(resp => {
    console.log("Mail sent for verification", resp);
    if (resp.success === true) {
      dispatch(v_mail_success(resp.status));
    } else {
      dispatch(v_mail_failed(resp.status));
    }
  }).catch(err => {
    console.log("an error occured", err);
    dispatch(v_mail_failed(err));
  })
}

export const r_reset_loading = () => ({
  type: prototype.R_SET_LOADING
});

export const r_reset_failed = (response) => ({
  type: prototype.R_SET_FAILED,
  payload: response
});

export const r_reset_success = (response) => ({
  type: prototype.R_SET_SUCCESS,
  payload: response
})

export const reset_password = (cred) => async (dispatch) => {
  dispatch(r_reset_loading(true));
  const obj = {
    newPassword: cred.password,
    confirmPassword: cred.confirmPassword,
    userId: cred.userId
  }

  fetch(baseURL + "/api/users/forgetPassword", {
    method: "POST",
    body: JSON.stringify(obj),
    headers: {
      "Content-Type": "application/json"
    }
  }).then(resp => resp.json())
  .then(resp => {
    console.log("password changed successfully", resp);
    if (resp.success === true) {
      dispatch(r_reset_success(resp.data));
    } else {
      dispatch(r_reset_failed(resp.status));
    }
  }).catch(err => {
    console.log("An error occurred while setting a new password.");
    dispatch(r_reset_failed(err));
  });
}


export const delete_a_resume = (id) => async (dispatch) => {
  const token = localStorage.getItem("token");
  const obj = {
    resumeId: id
  }
  fetch(baseURL + "/api/resumeUpload/delresume", {
    method: "DELETE",
    body: JSON.stringify(obj),
    headers: {
      "Content-Type": "application/json",
      "Authorization": "Bearer " + token
    }
  }).then(resp => resp.json())
  .then(resp => {
    console.log("Resume deleted", resp);
    dispatch(getting_successful(resp.data));
  }).catch(err => {
    console.log("An error occurred while deleting a cv");
  });
}

export const ActivitiesDetails = (activities) => ({
  type: prototype.ACTIVITIES,
  payload: activities
})

export const ActivitiesDetails_loading = () => ({
  type: prototype.ACTIVITIES_LOADING
})

// dispatch activities into the store
export const dispatchActivites = (activities) => (dispatch) => {
  dispatch(ActivitiesDetails(activities))
}

export const skillsDetails = (skills) => ({
  type: prototype.SKILLS,
  payload: skills
})

export const skillsDetails_loading = () => ({
  type: prototype.SKILLS_LOADING
})

// dispatch skills into the store
export const dispatchSkills = (skills) => (dispatch) => {
  dispatch(skillsDetails(skills))
}

export const p_skillsDetails = (pskills) => ({
  type: prototype.PERSONAL_SKILLS,
  payload: pskills
})

export const p_skillsDetails_loading = () => ({
  type: prototype.PERSONAL_SKILLS_LOADING
})

// dispatch skills into the store
export const dispatchPskills = (pskills) => (dispatch) => {
  dispatch(p_skillsDetails(pskills))
}

export const JobtitleDetails = (jobtitle) => ({
  type: prototype.JOBTITLE,
  payload: jobtitle
})

export const JobtitleDetails_loading = () => ({
  type: prototype.JOBTITLE_LOADING
})

// dispatch job title into the store
export const dispatchJobtitle = (Jobtitle) => (dispatch) => {
  dispatch(JobtitleDetails(Jobtitle))
}

export const EducationDetails = (education) => ({
  type: prototype.EDUCATION,
  payload: education
})

export const EducationDetails_loading = () => ({
  type: prototype.EDUCATION_LOADING
})

// dispatch activities into the store
export const dispatchEducation = (education) => (dispatch) => {
  dispatch(EducationDetails(education))
}


export const VoluntaryDetails = (voluntary) => ({
  type: prototype.VOLUNTARY,
  payload: voluntary
})

export const VoluntaryDetails_loading = () => ({
  type: prototype.VOLUNTARY_LOADING
})

// dispatch activities into the store
export const dispatchVoluntary = (voluntary) => (dispatch) => {
  dispatch(VoluntaryDetails(voluntary))
}

export const AwardDetails = (award) => ({
  type: prototype.AWARD,
  payload: award
})

export const AwardDetails_loading = () => ({
  type: prototype.AWARD_LOADING
})

// dispatch activities into the store
export const dispatchAward = (award) => (dispatch) => {
  dispatch(AwardDetails(award));
}


export const ReferenceDetails = (ref) => ({
  type: prototype.REFERENCE,
  payload: ref
})

export const ReferenceDetails_loading = () => ({
  type: prototype.REFERENCE_LOADING
})

// dispatch activities into the store
export const dispatchReference = (ref) => (dispatch) => {
  dispatch(ReferenceDetails(ref));
}

export const LanguageDetails = (lang) => ({
  type: prototype.LANGUAGE,
  payload: lang
})

export const LanguageDetails_loading = () => ({
  type: prototype.LANGUAGE_LOADING
})

// dispatch activities into the store
export const dispatchLanguage = (lang) => (dispatch) => {
  dispatch(LanguageDetails(lang));
}

export const LanguageTranslate = (lg) => ({
  type: prototype.LANGUAGE_TRANSLATION,
  payload: lg
})

export const LanguageTranslate_loading = () => ({
  type: prototype.LANGUAGE_TRANSLATION_LOADING
})

// dispatch activities into the store
export const dispatchT_Language = (lg) => (dispatch) => {
  dispatch(LanguageTranslate(lg));
}



export const clearStoredValue = () => (dispatch) => {
  dispatch(LanguageDetails_loading(true));
  dispatch(ActivitiesDetails_loading(true));
  dispatch(skillsDetails_loading(true));
  dispatch(JobtitleDetails_loading(true));
  dispatch(EducationDetails_loading(true));
  dispatch(AwardDetails_loading(true));
  dispatch(ReferenceDetails_loading(true));
  dispatch(p_skillsDetails_loading(true));
  dispatch(personal_loading(true));
}

export const secret_loading = () => ({
  type: prototype.SECRET_LOADING
})

export const save_secret_success = (err) => ({
  type: prototype.SECRET,
  payload: err
})


export const save_secret = (secret) => async (dispatch) => {
  dispatch(save_secret_success(secret));
}

export const personal_loading = () => ({
  type: prototype.PERSONAL_INFO_LOADING
})

export const personal_failed = (err) => ({
  type: prototype.PERSONAL_INFO_FAILED,
  payload: err
})

export const personal_info = (info) => ({
  type: prototype.PERSONAL_INFO,
  payload: info
})

export const personal_information = (info) => async (dispatch) => {
  dispatch(personal_loading(true));

  // perform a posting save to the database here

  dispatch(personal_info(info));
}

// initailize start
// function to save users cv details to the backend
export const save_personal_details = (details, id, clientSecret ) => async (dispatch) => {
  const token = localStorage.getItem('token');
  // do something here with the details argument.
  const value = {
    Fullname: details.Firstname + " " + details.LastName,
    Address: details.Address,
    Email: details.Email,
    Phone_number: details.Phone_number,
    Linkedin: details.Linkedin,
    Website: details.Website,
    pdfId: id,
    Secret: clientSecret
  }
  return fetch(baseURL + "/api/resumeUpload/initializeRes", {
    method: "POST",
    body: JSON.stringify(value),
    headers: {
      "Content-Type": "application/json",
      "Authorization": "Bearer " + token
    }
  }).then(resp => resp.json())
  .then(resp => {
    console.log("Personal information saved successfully.", resp);
    if (resp.data !== null) {
      dispatch(userInfo(resp.data));
    }
  }).catch(err => {
    throw err;
  });
}

export const saveEducation = (education, secret) => async (dispatch) => {
  // make an update api call
  const obj = {
    Secret: secret,
    Education: education
  }
  return fetch(baseURL + "/api/resumeUpload/initializeEducation", {
    method: "PUT",
    body: JSON.stringify(obj),
    headers: {
      "Content-Type": "application/json",
      "Authorization": "Bearer " + localStorage.getItem("token")
    },
  }).then(resp => resp.json())
  .then(resp => {
    console.log("Initialize education updated successfully.", resp);
  }).catch(err => console.log(err));
}

export const saveExperience = (experience, secret) => async (dispatch) => {
  // make an update api call
  const obj = {
    Secret: secret,
    Experience: experience
  }
  return fetch(baseURL + "/api/resumeUpload/initializeExperience", {
    method: "PUT",
    body: JSON.stringify(obj),
    headers: {
      "Content-Type": "application/json",
      "Authorization": "Bearer " + localStorage.getItem("token")
    },
  }).then(resp => resp.json())
  .then(resp => {
    console.log("Initialize experience updated successfully.", resp);
  }).catch(err => console.log(err));
}

export const saveLanguage = (language, secret) => async (dispatch) => {
  // make an update api call
  const obj = {
    Secret: secret,
    Language: language
  }
  return fetch(baseURL + "/api/resumeUpload/initializeLanguage", {
    method: "PUT",
    body: JSON.stringify(obj),
    headers: {
      "Content-Type": "application/json",
      "Authorization": "Bearer " + localStorage.getItem("token")
    },
  }).then(resp => resp.json())
  .then(resp => {
    console.log("Initialize language updated successfully.", resp);
  }).catch(err => console.log(err));
}

export const saveSkills = (t_skills, p_skills, secret) => async (dispatch) => {
  // make an update api call
  const obj = {
    Secret: secret,
    Technical_skills: t_skills,
    Personal_skills: p_skills
  }
  return fetch(baseURL + "/api/resumeUpload/initializeSkills", {
    method: "PUT",
    body: JSON.stringify(obj),
    headers: {
      "Content-Type": "application/json",
      "Authorization": "Bearer " + localStorage.getItem("token")
    },
  }).then(resp => resp.json())
  .then(resp => {
    console.log("Initialize skills updated successfully.", resp);
  }).catch(err => console.log(err));
}

export const saveJobAndSum = (title, summary, secret) => async (dispatch) => {
  // make an update api call
  const obj = {
    Secret: secret,
    CvType: title,
    Professional_summary: summary
  }
  return fetch(baseURL + "/api/resumeUpload/initializeTypeSum", {
    method: "PUT",
    body: JSON.stringify(obj),
    headers: {
      "Content-Type": "application/json",
      "Authorization": "Bearer " + localStorage.getItem("token")
    },
  }).then(resp => resp.json())
  .then(resp => {
    console.log("Initialize job type and professional summary updated successfully.", resp);
  }).catch(err => console.log(err));
}

export const saveAward = (award, secret) => async (dispatch) => {
  // make an update api call
  const obj = {
    Secret: secret,
    Award: award
  }
  return fetch(baseURL + "/api/resumeUpload/initializeAward", {
    method: "PUT",
    body: JSON.stringify(obj),
    headers: {
      "Content-Type": "application/json",
      "Authorization": "Bearer " + localStorage.getItem("token")
    },
  }).then(resp => resp.json())
  .then(resp => {
    console.log("Initialize award updated successfully.", resp);
  }).catch(err => console.log(err));
}

export const saveReference = (reference, secret) => async (dispatch) => {
  // make an update api call
  const obj = {
    Secret: secret,
    Reference: reference
  }
  return fetch(baseURL + "/api/resumeUpload/initializeReference", {
    method: "PUT",
    body: JSON.stringify(obj),
    headers: {
      "Content-Type": "application/json",
      "Authorization": "Bearer " + localStorage.getItem("token")
    },
  }).then(resp => resp.json())
  .then(resp => {
    console.log("Initialize reference updated successfully.", resp);
  }).catch(err => console.log(err));
}

// initialize end
export const cert_loading = () => ({
  type: prototype.CERT_LOADING
})

export const cert_success = (cert) => ({
  type: prototype.CERT,
  payload: cert
})

export const cert_function = (cert) => async (dispatch) => {
  dispatch(cert_success(cert));
}

export const lang_loading = () => ({
  type: prototype.LANG_LOADING
})

export const lang_success = (lang) => ({
  type: prototype.LANG,
  payload: lang
})
// resume language
export const lang_function = (cert) => async (dispatch) => {
  dispatch(lang_success(cert));
}

export const resume_step_add_function = () => (
  {
    type: prototype.RESUME_STEP_ADD,
  }
)

export const resume_step_sub_function = () => (
  {
    type: prototype.RESUME_STEP_SUB,
  }
)
export const resume_step_jump_function = (step) => (
  {
    type: prototype.RESUME_STEP_JUMP,
    payload: step
  }
)


